// @flow
import React, { Component } from 'react';
import Highlighter from 'react-highlight-words';
import moment from 'moment';
import {
    ProductNameBox,
    Checkbox,
    Dropdown,
    Button,
    Icon,
} from '../../../common/';
import I18n from '../../../../i18n/I18n';
import Helper from '../../../../helper/Helper';
import styles from '../../../orders/orderTable/orderBox/OrderBox.scss';

class ProductRowBox extends Component {
    state = { isPaneOpen: false };

    openModal = () => {
        this.setState({
            isPaneOpen: true,
        });
    };
    onCloseModal = () => {
        this.setState({
            isPaneOpen: false,
        });
    };

    render() {
        const { item, searchString, property, seller } = this.props;

        return (
            <div className={styles.ctr}>
                <div className={styles.flexer}>
                    <div>
                        <a
                            target="_blank"
                            href={`${Helper.getAppDomain(
                                'catalog',
                            )}/${Helper.getLocale()}/catalog/${
                                item.psku_canonical
                            }`}
                        >
                            <ProductNameBox
                                data={item}
                                searchString={searchString}
                            />
                        </a>
                    </div>
                    <div className={styles.statusCtr}>
                        <div
                            className={`${styles.iconStatus} ${styles.status} ${
                                styles[item.status_code]
                            }`}
                        >
                            {item.status}
                        </div>
                    </div>
                </div>
                <div className={styles.descCtr}>
                    <div className={styles.attrCtr}>
                        {item.sku ? (
                            <div className={styles.eachAttr}>
                                <h6 className={styles.attrTitle}>
                                    {I18n.getText('product-table.sku')}
                                </h6>
                                <div className={styles.attrVal}>
                                    <Highlighter
                                        highlightClassName={styles.highlight}
                                        searchWords={[searchString]}
                                        autoEscape={true}
                                        textToHighlight={item.sku}
                                    />
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        {item.item_nr ? (
                            <div className={styles.eachAttr}>
                                <h6 className={styles.attrTitle}>
                                    {I18n.getText('order-details.item-nr')}
                                </h6>
                                <div className={styles.attrVal}>
                                    <Highlighter
                                        highlightClassName={styles.highlight}
                                        searchWords={[searchString]}
                                        autoEscape={true}
                                        textToHighlight={item.item_nr}
                                    />
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        {item.invoice_date ? (
                            <div className={styles.eachAttr}>
                                <h6 className={styles.attrTitle}>
                                    {I18n.getText('sales.invoice-date')}
                                </h6>
                                <div className={styles.attrVal}>
                                    {item && item.invoice_date
                                        ? moment(item.invoice_date).format(
                                              `YYYY-MM-DD`,
                                          )
                                        : '-'}
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        {item.warehouse_name ? (
                            <div className={styles.eachAttr}>
                                <h6 className={styles.attrTitle}>
                                    {I18n.getText('sales.origin-country')}
                                </h6>
                                <div className={styles.attrVal}>
                                    {item.warehouse_name}
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        {item.customer_country_code ? (
                            <div className={styles.eachAttr}>
                                <h6 className={styles.attrTitle}>
                                    {I18n.getText('sales.destination-country')}
                                </h6>
                                <div className={styles.attrVal}>
                                    {item.customer_country_code}
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        {item.partner_sku_unique ? (
                            <div className={styles.eachAttr}>
                                <h6 className={styles.attrTitle}>
                                    {I18n.getText('offer.p-sku-unique')}
                                </h6>
                                <div className={styles.attrVal}>
                                    <Highlighter
                                        highlightClassName={styles.highlight}
                                        searchWords={[searchString]}
                                        autoEscape={true}
                                        textToHighlight={
                                            item.partner_sku_unique
                                        }
                                    />
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        <div className={styles.eachAttr}>
                            <h6 className={styles.attrTitle}>
                                {I18n.getText('sales.base-price')}
                            </h6>
                            <div className={styles.attrVal}>
                                {I18n.formatCurrency(
                                    Helper.formatPrice(
                                        item.base_price,
                                        seller && seller.currency_code,
                                    ),
                                )}
                            </div>
                        </div>
                        <div className={styles.eachAttr}>
                            <h6 className={styles.attrTitle}>
                                {I18n.getText('sales.fees')}
                            </h6>
                            <div className={styles.attrVal}>
                                {I18n.formatCurrency(
                                    Helper.formatPrice(
                                        item.total_fees,
                                        seller && seller.currency_code,
                                    ),
                                )}
                            </div>
                        </div>
                        <div className={styles.eachAttr}>
                            <h6 className={styles.attrTitle}>
                                {I18n.getText('sales.pending-payment')}
                            </h6>
                            <div className={styles.attrVal}>
                                {I18n.formatCurrency(
                                    Helper.formatPrice(
                                        item.net_due,
                                        seller && seller.currency_code,
                                    ),
                                )}
                            </div>
                        </div>

                        <div className={styles.eachAttr}>
                            <h6 className={styles.attrTitle}>
                                {I18n.getText('sales.net-payment')}
                            </h6>
                            <div className={styles.attrVal}>
                                {I18n.formatCurrency(
                                    Helper.formatPrice(
                                        item.net_paid,
                                        seller && seller.currency_code,
                                    ),
                                )}
                                <a
                                    href={`/${Helper.getLocale()}/sales/${
                                        item.item_nr
                                    }`}
                                    className={styles.viewMoreBtn}
                                >
                                    {I18n.getText('sales.view-more')}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default ProductRowBox;



// WEBPACK FOOTER //
// ./src/components/sales/salesTable/salesRowBox/SalesRowBox.js